import { formatDateOnly } from "../../utils/DateTimeUtil";

/**
 * Format date for subscription display
 * Uses centralized DateTimeUtil for consistent formatting
 */
export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  return formatDateOnly(dateString, "short");
};

export const getTodayISOString = () => {
  const today = new Date();
  return today.toISOString();
};

export const getStatusBadgeClass = (status) => {
  console.log("🏷️ Getting status badge class for status:", status);
  const statusClass = (() => {
    switch (status?.toLowerCase()) {
      case "active":
        return "status-badge active";
      case "inactive":
        return "status-badge inactive";
      case "cancelled":
        return "status-badge cancelled";
      case "expired":
        return "status-badge expired";
      case "trial":
        return "status-badge trial";
      default:
        return "status-badge";
    }
  })();
  console.log("🏷️ Status badge class result:", statusClass);
  return statusClass;
};
